// import React from 'react'
// import ReactDOM from 'react-dom'
import './index.scss'
// import reportWebVitals from './reportWebVitals'
//just test git
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import PathNotOk from './components/PathNotOk'
import {
  RestrictedProvider,
  UserProvider,
  ListSessionsWSProvider,
  SessionWSProvider,
  TrkptsWSProvider,
  ListBoardsProvider,
  ListSailsProvider,
  LangProvider,
  MobileProvider,
} from './utils/context'

import Home from './pages/Home'
import Try from './pages/Try'
import Login from './pages/Login'
import Sessions from './pages/Sessions'
import SessionWSStats from './pages/SessionWSStats'
import SessionWSTracks from './pages/SessionWSTracks'
import ModifySession from './pages/ModifySession'
import Boards from './pages/Boards'
import Sails from './pages/Sails'
import GlobalStats from './pages/GlobalStats'
import RigsStats from './pages/RigsStats'
import Meteo from './pages/Meteo'
import TestZip from './pages/TestZip'
import Fkw from './components/Fkw'

import Header from './components/Header'
import Rigs from './pages/Rigs'
import ModifyProfile from './pages/ModifyProfile'
import CGU from './pages/CGU'
import Stats2 from './pages/Stats2'

const fkw_url = 'https://www.fkwave.com'
const App = () => {
  return (
    <Router>
      <MobileProvider>
        <LangProvider>
          <RestrictedProvider>
            <UserProvider>
              <ListSessionsWSProvider>
                <SessionWSProvider>
                  <TrkptsWSProvider>
                    <ListBoardsProvider>
                      <ListSailsProvider>
                        <Header></Header>
                        <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/try/:origin" element={<Try />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/sessions/" element={<Sessions />} />
                          <Route path="/testzip/" element={<TestZip />} />
                          <Route
                            path="/oneSessionStats/"
                            element={<SessionWSStats />}
                          />
                          <Route
                            path="/oneSessionStats2/"
                            element={<Stats2 />}
                          />
                          <Route
                            path="/oneSessionTracks/"
                            element={<SessionWSTracks />}
                          />
                          <Route path="/modify/" element={<ModifySession />} />

                          <Route path="/boards" element={<Boards />} />
                          <Route path="/sails" element={<Sails />} />
                          <Route path="/rigs" element={<Rigs />} />
                          <Route
                            path="/globalStats"
                            element={<GlobalStats />}
                          />
                          <Route path="/rigsStats" element={<RigsStats />} />
                          <Route path="/meteo" element={<Meteo />} />
                          <Route
                            path="/modifyProfile"
                            element={<ModifyProfile />}
                          />
                          <Route path="/fkw" element={<Fkw url={fkw_url} />} />
                          <Route path="/cgu" element={<CGU />} />
                          <Route path="*" element={<PathNotOk />} />
                        </Routes>
                        {/* <Footer></Footer> */}
                      </ListSailsProvider>
                    </ListBoardsProvider>
                  </TrkptsWSProvider>
                </SessionWSProvider>
              </ListSessionsWSProvider>
            </UserProvider>
          </RestrictedProvider>
        </LangProvider>
      </MobileProvider>
    </Router>
  )
}

export default App
